/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ClaimsSchema } from './ClaimsSchema';

export const PublishedCredentialSchema: core.serialization.ObjectSchema<
    serializers.PublishedCredentialSchema.Raw,
    Truvity.PublishedCredentialSchema
> = core.serialization.object({
    digestMultibase: core.serialization.property('digest_multibase', core.serialization.string()),
    jsonLdVocabDigestMultibase: core.serialization.property(
        'json_ld_vocab_digest_multibase',
        core.serialization.string(),
    ),
    jsonLdVocabUrl: core.serialization.property('json_ld_vocab_url', core.serialization.string()),
    jsonSchemaDigestMultibase: core.serialization.property('json_schema_digest_multibase', core.serialization.string()),
    jsonSchemaUrl: core.serialization.property('json_schema_url', core.serialization.string()),
    publishedAt: core.serialization.property('published_at', core.serialization.date()),
    schema: ClaimsSchema,
    slug: core.serialization.string(),
    url: core.serialization.string(),
    vcdmJsonSchemaDigestMultibase: core.serialization.property(
        'vcdm_json_schema_digest_multibase',
        core.serialization.string(),
    ),
    vcdmJsonSchemaUrl: core.serialization.property('vcdm_json_schema_url', core.serialization.string()),
    version: core.serialization.number(),
});

export declare namespace PublishedCredentialSchema {
    export interface Raw {
        digest_multibase: string;
        json_ld_vocab_digest_multibase: string;
        json_ld_vocab_url: string;
        json_schema_digest_multibase: string;
        json_schema_url: string;
        published_at: string;
        schema: ClaimsSchema.Raw;
        slug: string;
        url: string;
        vcdm_json_schema_digest_multibase: string;
        vcdm_json_schema_url: string;
        version: number;
    }
}
